import {Card, Col, Row} from "react-bootstrap";
import React from "react";

const Report = ()=>{
    return (
        <>
            <h4 className="mt-4 text-center">รายงานผลการใช้งานห้อง Smart Classroom & Studio ของศูนย์นวัตกรรมการเรียนการสอน</h4>
            <div className="mt-4 text-center">
                <iframe width="100%" height="1020"
                        src="https://datastudio.google.com/embed/reporting/df366422-e5c8-4a58-b373-0297ec3b3137/page/qgR"
                        frameBorder="0" style={{border:0}} allowFullScreen></iframe>
            </div>

        </>
        )
}
export default Report
